import React,{useEffect,useState,useRef} from "react";
import { data, useNavigate, useParams } from "react-router-dom";
import { getValue } from '@syncfusion/ej2-base';
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Resize,
  Sort,
  ContextMenu,
  Filter,
  Page,
  ExcelExport,
  PdfExport,
  Edit,
  Inject,
  Toolbar,
} from "@syncfusion/ej2-react-grids";
import { DialogComponent,DialogUtility } from '@syncfusion/ej2-react-popups';
import { DropDownListComponent  } from '@syncfusion/ej2-react-dropdowns';
import { ButtonComponent } from "@syncfusion/ej2-react-buttons";

import { 
         ordersGrid,
         modelOrdersGrid,
         orderItemsGrid,
         GetPadItemsData,
         paymentTypeData,

        } from "../data/orders";

import { ordersData, 
         FixOrders,
         voidOrders,
         addPADOrder,
         addTips,

        } from "../data/reportOrders";        
import { Header } from "../components";
import { useStateContext } from "../contexts/ContextProvider";
import { toCurrency } from "../tools/currency";
import { toDateShort } from "../tools/datetime";
import { ShowToast} from "../tools/extras";

const ReportDetail = () => {
  const gridcomp = useRef();
  const gridModal = useRef();
  const compBox = useRef();
  const compBox2 = useRef();
  const compBox3 = useRef();
  const compBox4 = useRef();
 
  const {currentMode} = useStateContext();
  const [Orders, setOrders] = useState([]);
  const [SelectedOrders, setSelectedOrders] = useState([]);
  const [OrderItems, setOrderItems] = useState([]);
  const [BOrders, setBOrders] = useState([]);

  const [MultipleOn, setMultipleOn] = useState(false);
  
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [padItemsData, setPadItemsData] = useState([]);

  const {sessionIID} = useParams();

  //const [selectedPAD, setSelectedPAD] = useState(['']);

  //let PadFields = { text: "EntityButtonName", value: "IID" };

  //modal
  const [visibilityDetail, setDialogVisibilityDetail] = useState(false);
  const [visibilityOrders, setDialogVisibilityOrders] = useState(false);
  const [visibilityOrder, setDialogVisibilityOrder] = useState(false);
  const [visibilityTips, setDialogVisibilityTips] = useState(false);
  
  const dialogClose = ()=> {
    setDialogVisibilityDetail(false);
    setDialogVisibilityOrders(false);
    setDialogVisibilityOrder(false);
    setDialogVisibilityTips(false);
  }

  const [info, setInfo] = useState({Total:0,Vat:0,WVat:0,NVat:0,Card:0,Cash:0,ServiceC:0,Discount:0});
  const [dateInfo, setDateInfo] = useState({Start:null,End:null});

  const bgcolor = currentMode === "Dark" ? "bg-gray-700" : "bg-white";

  const toolbarOptions = ['ExcelExport'];

  const eSettings = {allowEditOnDblClick: false};
  const sSettings = { type: 'Multiple', mode: 'Row'};

  const toolbarClick = (args) => {
    if (args.item.text === 'Excel Export' || args.item.id.includes('excelexport')) {
      const excelExportProperties = {
        fileName: `Report_Detail_${dateInfo.Start}_${dateInfo.End}.xlsx`
      };
      if (gridcomp.current) {
        gridcomp.current.excelExport(excelExportProperties);
      }
    }
  };

  const actionBegin = (args) => {
    if (args.requestType === 'save') {
      //alert(args.rowData.OrderID);
    }
  };

  const rowSelected = (args) => {  
    //alert(args.data.UserName)
    setSelectedProduct(args.data);
  }
  const ShowAll=()=>{
    //document.getElementById("rdPaid").checked = false;
    //document.getElementById("rdUnpaid").checked = false;
    
    document.getElementById("rdCash").checked = false;
    document.getElementById("rdCard").checked = false;

    //console.log(gStatus);
    setOrders(BOrders);
    setInfo(calculateTotals(BOrders));
  }
  
  const [filterStatus, setFilterStatus] = useState("");
  const ShowFiltered=()=>{    
    let bOrders = BOrders
    /*if(document.getElementById("rdPaid").checked === true && filterStatus !== "Paid"){      
      bOrders = bOrders.filter((item) => item.Status > 2);
      setFilterStatus("Paid");
    }else if(document.getElementById("rdUnpaid").checked === true && filterStatus !== "Unpaid"){     
      bOrders = bOrders.filter((item) => item.Status < 3);
      setFilterStatus("Unpaid");
    }else*/ if(document.getElementById("rdCash").checked === true && filterStatus !== "Cash"){  
      bOrders = bOrders.filter((item) => item.Payment === 1);
      setFilterStatus("Cash");
    }else if(document.getElementById("rdCard").checked === true && filterStatus !== "Card"){
      bOrders = bOrders.filter((item) => item.Payment === 3);
      setFilterStatus("Card");
    }
    
    if(bOrders === BOrders){
      setFilterStatus("");
      ShowAll();
    }else{
      setOrders(bOrders);
      setInfo(calculateTotals(bOrders));
    }
  }
  const calculateTotals=(dataorder)=>{
    let WVat = dataorder.reduce((acc,item) => acc + parseFloat(item.WVat),0);     
    let NVat = dataorder.reduce((acc,item) => acc + parseFloat(item.NVat),0);         
    let vat = dataorder.reduce((acc,item) => acc + parseFloat(item.vat),0);
    let total = dataorder.reduce((acc,item) => acc + parseFloat(item.total),0);
    let cash = dataorder.reduce((acc,item) => acc + ((item.Payment===1?parseFloat(item.NVat)+parseFloat(item.WVat):0)),0);
    let card = dataorder.reduce((acc,item) => acc + ((item.Payment===3?parseFloat(item.NVat)+parseFloat(item.WVat):0)),0);
    let ServiceC = dataorder.reduce((acc,item) => acc + parseFloat(item.ServiceC),0);
    let discount = dataorder.reduce((acc,item) => acc + parseFloat(item.Discount),0);

    let myInfo ={};

    
    myInfo.Vat = toCurrency(vat);
    myInfo.WVat = toCurrency(WVat);
    myInfo.NVat = toCurrency(NVat);
    myInfo.Cash = toCurrency(cash);
    myInfo.Card = toCurrency(card);
    myInfo.Total = toCurrency(total);
    myInfo.ServiceC = toCurrency(ServiceC);
    myInfo.Discount = toCurrency(discount);
    
    return myInfo;
  }

  const getOrders = (fn=(data)=>{}) => {
      
    GetPadItemsData((pdata)=>setPadItemsData(pdata)); //get PAD Items
      
      setOrders([]);//clean the grid before loading      
      ordersData((dataorder,dataSession)=>{ 
        setBOrders(dataorder);// leading data to Backup
        setOrders(dataorder);// leading data to the grid        
        setInfo(calculateTotals(dataorder));
        setDateInfo({Start:toDateShort(dataSession.StartDate),End:toDateShort(dataSession.EndDate)});
        fn(dataorder);
      },sessionIID); 
  }


  const Details=()=>{
    if(MultipleOn===false){
      if(gridcomp.current.selectedRowIndex>=0)
      {
        var btnSendEmail = document.getElementById('sendEmail')
        if(btnSendEmail!==undefined && btnSendEmail.getAttribute('listener') !== 'true') {
          btnSendEmail.addEventListener('click',()=>{alert("Still in development!")});
          btnSendEmail.setAttribute('listener', 'true');
        }

        setDialogVisibilityDetail(true);
        setOrderItems(selectedProduct.sub);
        document.getElementById('orderitemtotal').innerText='Total : ' + toCurrency(selectedProduct.total);
        document.getElementById('orderitemvat').innerText='VAT : ' + toCurrency(selectedProduct.vat);
      }    
    }
    else
    {
      if(gridcomp.current.selectedRowIndex>=0)
        {
        setSelectedOrders(gridcomp.current.getSelectedRecords());
        setDialogVisibilityOrders(true);

        var btnFixOrder = document.getElementById('changeModalOrder');
        //btnFixOrder.addEventListener('click',ChangeOrder); 
        if(btnFixOrder!==undefined && btnFixOrder.getAttribute('listener') !== 'true') {
          btnFixOrder.addEventListener('click',()=>{
            if(compBox.current.itemData === null){
              alert('Select an Item');
              return;
            }
            
            let idList = gridModal.current.dataSource.map((item) => item.IID);
            FixOrders(compBox.current.itemData.value,idList,FixedOrders);
          });
          btnFixOrder.setAttribute('listener', 'true');
        }
      }
    }
  }

  const AddOrderModal=()=>{
    //console.log('Add an Order');
    var btnAddOrder = document.getElementById('addPriceModalOrder')
    if(btnAddOrder!==undefined && btnAddOrder.getAttribute('listener') !== 'true') {
      btnAddOrder.addEventListener('click',()=>{
        //console.log('Add an Order');
        if(compBox2.current.itemData === null){
          alert('Select an Item');
          return
        }
        
        if(compBox3.current.value === null){
          alert('Select an Item');
          return
        }
        if(document.getElementById('txtPrice').value*1 === 0){
          alert('Select enter a price');
          return
        }
        let Price= document.getElementById('txtPrice').value*1;
        let EntityButtonIID = compBox2.current.itemData.value;
        let PaymentType = compBox3.current.itemData.value;

        addPADOrder(sessionIID,Price,EntityButtonIID,PaymentType,(data)=>{
          //console.log(data);
          if(data.success === true){
            ShowToast({content:`Order Added`,type:'Success'});
            getOrders();
            setDialogVisibilityOrder(false);
          }else{
            ShowToast({content:`Error: ${data.message}`,type:'Error'});
          }
          
        });      
      });
      btnAddOrder.setAttribute('listener', 'true');
    }
  }

  const AddTipsModal=()=>{
    //console.log('Add an Tips');
    var btnAddTips = document.getElementById('addPriceModalTip')
    if(btnAddTips!==undefined && btnAddTips.getAttribute('listener') !== 'true') {
      btnAddTips.addEventListener('click',()=>{
        
        if(document.getElementById('txtTipPrice').value*1 === 0){
          alert('Select enter a price');
          return
        }
        let Price= document.getElementById('txtTipPrice').value*1;
        let PaymentType = compBox4.current.itemData.value;

        addTips(sessionIID,Price,PaymentType,(data)=>{
          //console.log(data);
          if(data.success === true){
            ShowToast({content:`Tips Added`,type:'Success'});
            getOrders();
            setDialogVisibilityTips(false);
          }else{
            ShowToast({content:`Error: ${data.message}`,type:'Error'});
          }
          
        });      
      });
      btnAddTips.setAttribute('listener', 'true');
    }
  } 



  const AddNewOrder=()=>{
    setDialogVisibilityOrder(true);    
  }

  const AddNewTips=()=>{
    setDialogVisibilityTips(true);    
  }
  const VoidOrders=()=>{
      let idList = gridcomp.current.getSelectedRecords().map((item) => item.IID);
      
      if(idList.length === 0){
        alert('Select an Order');
        return;
      }
       let dialogConfirm = DialogUtility.confirm({      
          //cancelButton: { text: 'Cancel', click: ()=>{console.log("gave up")} },
          closeOnEscape: false,
          content: "When you delete it, there is no option to get it back. Please think twice before deleting anything!",
          okButton: { text: 'DELETE IT', click: ()=>{ 
            let idList = gridcomp.current.getSelectedRecords().map((item) => item.IID);
            voidOrders(idList,(data)=>{
              //.log(data);
              if(data.success === true){
                ShowToast({content:`Orders Voided`,type:'Success'});
                getOrders();
                dialogConfirm.hide();
              }else{
                ShowToast({content:`Error: ${data.message}`,type:'Error'});
              }
            });
          }},
          showCloseIcon: true,
          title: 'Do you really want to void these orders?',  
        }); 
  }

  
  const FixedOrders=(result)=>{
    //dialogClose();
    //ShowToast('Orders Fixed');
    getOrders((data)=>{
      let idList = gridModal.current.dataSource.map((item) => item.IID);
      setSelectedOrders(data.filter((item) => idList.includes(item.IID)));
      ShowToast({content:`Orders Fixed`,type:'Success'});
    });
    //console.log('Orders Fixed');
    //gridcomp.dataSource = [];
  }

  const makeSimpleOrder = (btnItem) => {
    if(MultipleOn===true){
      setMultipleOn(false);
      gridcomp.current.selectionSettings.enableSimpleMultiRowSelection= false;
      btnItem.target.innerText = 'Order';
      gridcomp.current.clearSelection();
    }else{ 
      setMultipleOn(true);
      gridcomp.current.selectionSettings.enableSimpleMultiRowSelection= true; 
      btnItem.target.innerText = 'Orders';
      //console.log();    

    }/**/
  }

 
  

  useEffect(() => {  
    getOrders();
    
    if(MultipleOn===false){

    }else{
      let modalInfo = calculateTotals(SelectedOrders);        
      document.getElementById('ordermodaltotal').innerText='Total : ' + modalInfo.Total;
      document.getElementById('ordermodalvat').innerText='VAT : ' + modalInfo.Vat;      
    } 

    AddOrderModal();
    AddTipsModal();

  },[SelectedOrders,MultipleOn]);
  

  return (
    <div className={"mx-5 rounded-2xl " + bgcolor} >
      <Header title={"Report Detail (" + dateInfo.Start + " - " + dateInfo.End + ")"} />   
      <div className="grid grid-cols-5 gap-2">       
        <div className="col-span-5">
        {}
        <div className="e-btn-group grid grid-cols-2 lg:grid-cols-4">
           <button 
              className="e-btn bg-orange-300 hover:bg-indigo-200 shadow-primary-1 p-2 font-medium uppercase rounded" 
          >Send To Till</button>
          <button  onClick={AddNewTips}
              className="e-btn bg-blue-300 hover:bg-indigo-200 shadow-primary-1 p-2 font-medium uppercase rounded" 
          >SERVICE CHARGE</button>
        </div>
        <div id="gStatus" className="e-btn-group grid grid-cols-2 lg:grid-cols-4">              
              <label className="e-btn bg-green-300 drop-shadow-md p-2 font-medium uppercase rounded has-[:checked]:bg-lime-300" >
                <input type="radio" id="rdCard" name="gFilter" value="card" onClick={ShowFiltered}  />
                CARD
              </label>
              <label className="e-btn bg-green-300 drop-shadow-md p-2 font-medium uppercase rounded has-[:checked]:bg-lime-300">
                <input type="radio" id="rdCash" name="gFilter" value="cash" onClick={ShowFiltered}   />
                CASH
              </label>  
        </div>
        <div className="e-btn-group grid grid-cols-2 lg:grid-cols-4">
          <button onClick={Details}
              className="e-btn bg-indigo-300 hover:bg-indigo-200 shadow-primary-1 p-2 font-medium uppercase rounded" 
          >Order Details</button>
          <button onClick={makeSimpleOrder.bind(this)}
              className="e-btn bg-yellow-300 hover:bg-indigo-200 shadow-primary-1 p-2 font-medium uppercase rounded"
          > Order</button>
                      
          <button onClick={AddNewOrder}
              className="e-btn bg-violet-300 hover:bg-indigo-200 shadow-primary-1 p-2 font-medium uppercase rounded"
          > Add Order</button>
          <button  onClick={VoidOrders}
              className="e-btn bg-rose-300 hover:bg-indigo-200 shadow-primary-1 p-2 font-medium uppercase rounded"
          > Void</button>
        </div>
      </div>
      <div className="col-span-5 grid grid-cols-2 gap-0.5">
          <label className="e-label text-sm text-right bg-zinc-50 pr-2 drop-shadow-md">Card : <b>{info.Card}</b></label>
          <label className="e-label text-sm text-right bg-zinc-50 pr-2 drop-shadow-md">Cash : <b>{info.Cash}</b></label>   
          <label className="e-label text-sm text-right bg-zinc-50 pr-2 drop-shadow-md">ServiceC/Tips : <b>{info.ServiceC}</b></label>
          <label className="e-label text-sm text-right bg-zinc-50 pr-2 drop-shadow-md">Discount : <b>{info.Discount}</b></label>   
          <label className="e-label text-sm text-right bg-zinc-50 pr-2 drop-shadow-md">W/ VAT : <b>{info.WVat}</b></label>
          <label className="e-label text-sm text-right bg-zinc-50 pr-2 drop-shadow-md">VAT Total  : <b>{info.Vat}</b></label>     
          <label className="e-label text-sm text-right bg-zinc-50 pr-2 drop-shadow-md">W/No VAT : <b>{info.NVat}</b></label>
          <label className="e-label text-sm text-right bg-zinc-50 pr-2 drop-shadow-md">Total : <b>{info.Total}</b></label>   
        </div>
      </div>  
      
      <GridComponent  ref={gridcomp} allowPaging allowSorting allowExcelExport={true} toolbar={toolbarOptions} selectionSettings={sSettings} dataSource={Orders}
                      actionBegin={actionBegin.bind(this)} toolbarClick={toolbarClick} rowSelected={rowSelected} sortSettings={ {columns: [{field: 'OrderDate', direction: 'Descending'}]}} > 
        <ColumnsDirective>
          {ordersGrid.map((item, index) => (
            <ColumnDirective key={index} {...item}  />
          ))}
        </ColumnsDirective>
        <Inject services={[Resize, Sort, ContextMenu, Filter, Page, ExcelExport, Edit, PdfExport,Toolbar]} />
      </GridComponent>

      <DialogComponent isModal={true}  id="modalDetails" showCloseIcon={true} visible={visibilityDetail} close={dialogClose} header="Order Details" 
      cssClass="e-fixed border-8 border-zing-500" width='600px' >
        <div >
          <div className="grid grid-cols-4 gap-2">
            <input type="text" id="txtEmail" placeholder="Email address to send as an Invoice"
              className="block flex-1 border-1 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6 col-span-3 lg:col-span-2 " />
            <button id="sendEmail"
                className="e-btn bg-sky-300 hover:bg-indigo-200 shadow-primary-1 p-2 font-medium uppercase rounded" 
                >Send Email</button>
              <div className="col-span-4 lg:col-span-1">
                <div id="orderitemtotal" className="e-label text-sm text-right bg-zinc-50 pr-2 drop-shadow-md"></div> 
                <div id="orderitemvat" className="e-label text-sm text-right bg-zinc-50 pr-2 drop-shadow-md"></div> 
            </div>
          </div>
          <GridComponent allowPaging allowSorting  editSettings={eSettings} dataSource={OrderItems}>
          <ColumnsDirective>
          {orderItemsGrid.map((item, index) => (
            <ColumnDirective key={index} {...item}  />
          ))}
        </ColumnsDirective>
        <Inject services={[Resize, Sort, ContextMenu, Filter, Page, ExcelExport, Edit, PdfExport,Toolbar]} />
      </GridComponent>
        </div>
      </DialogComponent>

      <DialogComponent isModal={true}  id="modalOrders" showCloseIcon={true} visible={visibilityOrders} close={dialogClose} header="Orders" 
      cssClass="e-fixed border-8 border-zing-500" width='600px' >
        <div >
          <div className="grid grid-cols-4 gap-2">
            <DropDownListComponent id="compBoxId" ref={compBox}   placeholder="Select an Item"  dataSource={padItemsData}    />
            <button  id="changeModalOrder" 
                className="e-btn bg-sky-300 hover:bg-indigo-200 shadow-primary-1 p-2 font-medium uppercase rounded" 
                >Fix it </button >
              <div className="col-span-4 lg:col-span-2">
                <div id="ordermodaltotal" className="e-label text-sm text-right bg-zinc-50 pr-2 drop-shadow-md"></div> 
                <div id="ordermodalvat" className="e-label text-sm text-right bg-zinc-50 pr-2 drop-shadow-md"></div> 
            </div>
          </div>
          <GridComponent ref={gridModal} allowPaging allowSorting  editSettings={eSettings} dataSource={SelectedOrders}>
          <ColumnsDirective>
          {modelOrdersGrid.map((item, index) => (
            <ColumnDirective key={index} {...item}  />
          ))}
        </ColumnsDirective>
        <Inject services={[Resize, Sort, ContextMenu, Filter, Page, ExcelExport, Edit, PdfExport,Toolbar]} />
      </GridComponent>
        </div>
      </DialogComponent>

      <DialogComponent isModal={true}  id="modalOrder" showCloseIcon={true} visible={visibilityOrder} close={dialogClose} header="Order" 
          cssClass="e-fixed border-8 border-zing-500" width='600px' >
        <div >
          <div className="grid grid-cols-4 gap-2">
            <input type="number" id="txtPrice" placeholder="Price" pattern="[0-9]{0,5}.[0-9]{0,2}"
              className="text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm text-right lg:col-span-1 col-span-4 " />
            <DropDownListComponent id="compBox2Id" ref={compBox2} placeholder="Select an Item"  dataSource={padItemsData}
              cssClass="text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm  lg:col-span-1 col-span-4 "
            />
            <DropDownListComponent id="compBox3Id" ref={compBox3} placeholder="Select an Item"  dataSource={paymentTypeData}
              cssClass="text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm lg:col-span-1 col-span-4 "
            />
            <button  id="addPriceModalOrder" 
                className="e-btn bg-sky-300 hover:bg-indigo-200 shadow-primary-1 p-2 font-medium uppercase rounded  lg:col-span-1 col-span-4" 
                >Add </button >              
          </div>          
        </div>
      </DialogComponent>

       <DialogComponent isModal={true}  id="modalTip" showCloseIcon={true} visible={visibilityTips} close={dialogClose} header="Service Charge /  Tips" 
          cssClass="e-fixed border-8 border-zing-500" width='600px' >
        <div >
          <div className="grid grid-cols-4 gap-2">
            <input type="number" id="txtTipPrice" placeholder="Price" pattern="[0-9]{0,5}.[0-9]{0,2}"
              className="text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm text-right lg:col-span-1 col-span-4 " />
            
            <DropDownListComponent id="compBox4Id" ref={compBox4} placeholder="Select an Item"  dataSource={paymentTypeData} 
              cssClass="text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm lg:col-span-1 col-span-4 "
            />
            <button  id="addPriceModalTip" 
                className="e-btn bg-sky-300 hover:bg-indigo-200 shadow-primary-1 p-2 font-medium uppercase rounded  lg:col-span-2 col-span-4" 
                >Add </button >              
          </div>          
        </div>
      </DialogComponent>
    </div>
  );
};

export default ReportDetail;
